import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import {
  Box,
  Stack,
  Typography,
  Button,
  IconButton,
  Avatar,
} from "@mui/material";
import Loader from "../../components/Loader";
import ApiService from "../../services/api-service";
import Back from "../../components/Back";
import { Images } from "../../assets/common";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ProfileMenu from "../../components/ProfileMenu";
import {
  convertHMS,
  copyToClipboard,
  generateDynamicLink,
  fullName,
  getErrorString,
  getUserDetail,
  isOwnerId,
  onShare,
  putRecors,
  truncate,
} from "../../constants/function";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import notifier from "../../components/Notifier";
import { useDispatch } from "react-redux";
import DoneIcon from "@mui/icons-material/Done";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import { addSongAction } from "../../action/songs";
import AddMusicToPlaylist from "../../components/AddMusicToPlaylist";
import BuyNow from "../../components/BuyNow";
import "./index.scss";
import SellPopup from "../../components/SellPopup";
import IosSwitch from "../../components/IOSSwitch";
import AuctionPopup from "../../components/AuctionPopup";
import CancelTwoToneIcon from "@mui/icons-material/CancelTwoTone";
import SuccessPopup from "../../components/SuccessPopup";
import BidPopup from "../../components/BidPopup";
import PlaylistNftMoreData from "./playlistNftMoreData";
import OutsideClickHandler from "react-outside-click-handler";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PlaylistMusic from "../MyMusic/playlistMusic";
import { arrayMoveImmutable } from "array-move";
import TipPopup from "../../components/TipPopup";
import { getBalance } from "../../asyncAction/asyncBalance";
import { useTranslation } from "react-i18next";
import IosShareIcon from "@mui/icons-material/IosShare";
import HMSTag from "../../components/HMS/hms";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export default function PlaylistNftDetail() {
  const userDetail = getUserDetail();
  const [option, setOption] = React.useState(false);
  const { t } = useTranslation("common");
  const [openBid, setOpenBid] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const [type, setType] = React.useState("playlist");
  const [showSell, setShowSell] = React.useState(false);
  const [showAuction, setShowAuction] = React.useState(false);
  const [showPlaylist, setShowPlaylist] = useState(false);
  const [owners, setOwners] = useState({});
  const [index, setIndex] = React.useState(-1);
  const [charge, setCharge] = React.useState({});
  const [inUsd, setInUsd] = React.useState(0);
  const [bidInUsd, setBidInUsd] = React.useState(0);

  const [buyOpen, setBuyOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const { nftId } = useParams();
  const { playlistNftId } = useParams();
  const [playlistDetail, setPlaylistDetail] = useState({});
  const history = useHistory();
  const dispatch = useDispatch();
  const [checked, setChecked] = React.useState(false);
  const [menu, setMenu] = React.useState(false);
  const [value, setValue] = React.useState(0);
  const [openTipPlaylistMusic, setOpenTipPlaylistMusic] = React.useState(false);
  const [musicArtist, setMusicArtist] = useState(null);
  const [musicId, setMusicId] = useState(null);
  const [selectedMusicId, setSelectedMusicId] = React.useState();
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [playListId, setPlayListId] = React.useState(null);
  const [createdBy, setCreatedBy] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isPrivate, setPrivate] = useState(false);
  const [tipOrStream, setTipOrStream] = useState("Tips");
  const [tipOrStreamList, setTipOrStreamList] = useState([]);
  const [openBuy, setOpenBuy] = useState(false);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const getPlaylistDetail = async (_id, sellingPrice, highestBid) => {
    try {
      getCharges(sellingPrice, highestBid);
      // setLoading(true);

      const response = await ApiService.PLAYLIST_DETAIL({
        _id: _id,
        pageNo: 1,
        pageSize: 16,
      });
      setPlaylistDetail({ ...response["result"] });
      const currentResponse = await individualSongTipper(_id);
      for (var i = 0; i < currentResponse.length; i++) {
        var elementPos = response["result"]["music"]
          .map(function (x) {
            return x._id;
          })
          .indexOf(currentResponse[i]["musicId"]);
        //console.log("element pos", elementPos);
        if (elementPos >= 0) {
          response["result"]["music"][elementPos].topTipperId = currentResponse[
            i
          ]["topTipperId"]
            ? currentResponse[i]["topTipperId"]
            : "";
          response["result"]["music"][elementPos].topTipperName =
            currentResponse[i]["topTipperName"]
              ? currentResponse[i]["topTipperName"]
              : "";
          response["result"]["music"][elementPos].topTipperProfile =
            currentResponse[i]["topTipperProfile"]
              ? currentResponse[i]["topTipperProfile"]
              : { filePath: "" };

          // response["result"]["music"][i].topTipperId = "";
          // response["result"]["music"][i].topTipperName = "";
          // response["result"]["music"][i].topTipperProfile = {"filePath" : ""};
        }
      }
      // setLoading(false);
    } catch (error) {
      // setLoading(false);
      if (
        getErrorString(error) ===
        "This is an explicit content you need to be above 18 to view it"
      ) {
        notifier.error(getErrorString(error));
        history.push("/app/Home");
      }
    }
  };
  const individualSongTipper = async (playlistID) => {
    try {
      const response = await ApiService.INDIVIDUAL_SONG_TIPPER({
        id: playlistID,
      });
      return response["result"];
    } catch (error) {
      //console.log(error);
      return [];
    }
  };

  const getNftDetails = async (nftId) => {
    try {
      setLoading(true);
      const response = await ApiService.PLAYLIST_NFT_BY_ID(nftId);
      if (response["result"] && response["result"]["playlistDetails"]) {
        setOwners(response["result"]);
        setChecked(response["result"]["private"]);
      }
      setPlayListId(response["result"]["id"]);
      setCreatedBy(response["result"]["_id"]);
      setIsSubscribed(response["result"]["isSubscribed"]);
      setPrivate(response["result"]["private"]);
      await getPlaylistDetail(
        response["result"]["id"],
        response["result"]["sellingPrice"],
        response["result"]["highestBid"]
      );

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const play = (index) => {
    if (playListId && !isOwnerId(createdBy) && !isSubscribed && isPrivate)
      notifier.error(t("notifier.error.toast5"));
    else if (
      playListId &&
      !isOwnerId(createdBy) &&
      typeof playlistDetail["music"][index]["uploader"] === "object" &&
      !playlistDetail["music"][index]["uploader"]["isSubscribed"] &&
      playlistDetail["music"][index]["private"]
    ) {
      notifier.error(t("notifier.error.toast5"));
    } else
      dispatch(
        addSongAction(
          playlistDetail["music"][index],
          playListId ? playListId : null,
          true
        )
      );
  };
  const toggleMenu = (value, id, index) => {
    setMenu(false);

    setSelectedMusicId(id);
    setSelectedIndex(index);

    if (value && id) makeAction(value, id, index);
    else if (value) makeAction(value);
  };
  const makeAction = (key, id, index) => {
    switch (key) {
      case "m1":
        playlistDetail["music"][index]?.nftId
          ? history.push(
            `/app/SongDetails/${playlistDetail["music"][index]?.nftId}?nft=true`
          )
          : history.push(`/app/SongDetails/${id}`);
        break;
      case "m3":
        if (playListId && !isOwnerId(createdBy) && !isSubscribed && isPrivate)
          notifier.error(t("notifier.error.toast15"));
        else {
          setShowPlaylist(true);
        }
        break;
      case "m6":
        markPrivate(id, index);
        break;
      case "m5":
        markPrivate(id, index);
        break;
      case "m2":
        if (playListId && !isOwnerId(createdBy) && !isSubscribed && isPrivate)
          notifier.error(t("notifier.error.toast5"));
        else if (
          playListId &&
          !isOwnerId(createdBy) &&
          typeof playlistDetail["music"][index]["uploader"] === "object" &&
          !playlistDetail["music"][index]["uploader"]["isSubscribed"] &&
          playlistDetail["music"][index]["private"]
        ) {
          notifier.error(t("notifier.error.toast5"));
        } else
          dispatch(
            addSongAction(
              playlistDetail["music"][index],
              playListId ? playListId : null,
              true
            )
          );
        break;
      case "m10":
        deleteSongFromPlaylist(
          playlistDetail["music"][index]["_id"],
          playListId,
          index
        );
        break;
      case "m8":
        if (isOwnerId(playlistDetail?.createdBy))
          history.push(
            `/app/NftDetail/${playlistDetail["music"][index]?.nftId}`
          );
        else if (
          !playlistDetail?.isSubscribed &&
          playlistDetail["music"][index].private
        ) {
          notifier.error(t("notifier.error.toast5"));
        } else
          playlistDetail["music"][index]?.nftId
            ? history.push(
              `/app/NftDetail/${playlistDetail["music"][index]?.nftId}`
            )
            : history.push(`/app/SongDetails/${id}`);
        break;
    }
  };
  const deleteSongFromPlaylist = async (musicId, playlistId, index) => {
    if (musicId && playlistId) {
      setLoading(true);
      try {
        const response = await ApiService.REMOVE_SONG_FROM_PLAYLIST({
          musicId: musicId,
          playlistId: playlistId,
        });
        const tempPlaylist = playlistDetail;
        tempPlaylist["music"].splice(index, 1);
        setPlaylistDetail({ ...tempPlaylist });
        setLoading(false);
      } catch (error) {
        notifier.error(getErrorString(error));
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    getNftDetails(nftId);
  }, []);

  const getCharges = async (sellingPrice, highestBid) => {
    try {
      const price = sellingPrice || 0;
      const response = await ApiService.CHARGES();
      setCharge({ ...response["result"] });
      setInUsd(price * response["result"]["rate"]);
      setBidInUsd(highestBid * response["result"]["rate"]);

      return response["result"]["rate"];
    } catch (error) {
      return 0;
    }
  };
  const handleSell = (sellAmount) => {
    if (sellAmount) {
      getNftDetails(nftId);
      setShowSell(false);
    } else {
      setShowSell(false);
    }
  };

  const markPrivate = async (id) => {
    try {
      const privacy = !owners.private;
      setLoading(true);
      const response = await ApiService.ASSET_PRIVACY({
        assetId: owners["_id"],
        type: "playlistNFT",
        private: privacy,
      });
      //making playlist publisc/private
      const temp = owners;
      setChecked(privacy);
      temp.private = privacy;
      setOwners({ ...temp });
      setLoading(false);
      notifier.success(response["result"]);
    } catch (error) {
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };
  const handleAuction = (sellAmount) => {
    if (sellAmount) {
      getNftDetails(nftId);
      setShowAuction(false);
    } else {
      setShowAuction(false);
    }
  };
  const cancelSell = async (type, nftId) => {
    try {
      setLoading(true);
      const payload = {
        nftId: nftId,
        type: type,
      };
      const response = await ApiService.CANCEL_SELL_V2(payload);
      setLoading(false);
      getNftDetails(nftId);
      notifier.success(t("notifier.success.toast6"));
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const cancelAuction = async (type) => {
    try {
      setLoading(true);
      const payload = {
        nftId: nftId,
        type: type,
      };
      const response = await ApiService.CANCEL_AUCTION_NFT_V2(payload);
      setLoading(false);
      getNftDetails(nftId);
      notifier.success(t("notifier.success.toast5"));
    } catch (error) {
      setLoading(false);
      notifier.error(getErrorString(error));
    }
  };
  const handleBid = (bidAmount) => {
    if (bidAmount) {
      const ownersDetail = owners;
      ownersDetail["highestBid"] = parseInt(bidAmount["amount"]);
      setOwners({ ...ownersDetail });
      setOpenBid(false);
      setShowSuccess(true);
    } else setOpenBid(false);
  };
  const onSortEnd = async ({ oldIndex, newIndex }) => {
    // setPlaylistDetail((playlistDetail) =>
    //   arrayMoveImmutable(playlistDetail["music"], oldIndex, newIndex)
    // );
    const data = arrayMoveImmutable(
      playlistDetail["music"],
      oldIndex,
      newIndex
    );
    const tempPlaylsit = playlistDetail;
    tempPlaylsit["music"] = data;

    setPlaylistDetail({ ...tempPlaylsit });
    const musicList = data.map((m) => m._id);
    try {
      const payload = {
        playlistId: playlistDetail["_id"],
        musicList: musicList,
      };
      await ApiService.SORT_PLAYLIST_MUSIC(payload);
    } catch (error) {
      notifier.error(getErrorString(error));
    }
  };
  const onSortStart = ({ node, index }) => {
    // const row = node.classList;
    // row.add('__sotable_table_row');
    node.style.display = "flex";
    node.style.flexDirection = "row";
    node.style.justifyContent = "space-between";
    node.style.marginLeft = "0";
    // node.children[2].style.display = 'flex';
    // node.children[2].style.alignItems = 'center';
    // node.children[2].style.justifyContent = 'flex-end';
    // node.style.paddingRight = '20px';
  };
  const updateBeforeSortStart = ({ node, index }) => {
    // const row = node.classList;
    // row.add('__sotable_table_row');
    node.style.display = "flex";
    node.style.flexDirection = "row";
    node.style.justifyContent = "space-between";
    // node.style.marginLeft = '20px';
    node.children[0].style.paddingLeft = "20px";
    node.children[3].style.paddingRight = "20px";
    node.children[1].style.display = "flex";
    node.children[1].style.flexDirection = "row";
    node.children[1].style.justifyContent = "space-between";
    node.children[0].style.width = "25%";
    node.children[1].style.width = "25%";
    // node.children[2].style.display = 'flex';
    // node.children[2].style.alignItems = 'center';
    node.children[2].style.textAlign = "right";

    node.children[2].style.width = "25%";
    node.children[3].style.width = "25%";
    node.children[3].style.textAlign = "right";

    // node.style.paddingRight = '20px';
  };
  const handleCloseTip = async (amount, id, type, currency) => {
    if (amount) {
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: type,
          currency: currency,
        };
        setLoading(true);
        const response = await ApiService.TIP_ARTIST(payload);
        setLoading(false);
        notifier.success(response["result"]);
        setOpenTipPlaylistMusic(false);
        setMusicId(null);
        setMusicArtist(null);
        dispatch(getBalance());
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTipPlaylistMusic(false);
    }
  };
  const handleBuyed = (bidAmount) => {
    if (bidAmount) {
      setOpenBuy(false);
      setShowSuccess(true);
      getNftDetails(nftId);
    } else {
      setOpenBuy(false);
    }
  };
  const handleClosed = () => {
    setOption(false);
  };
  const handleCopy = async (action) => {
    const thumbnail = playlistDetail.GIF?.filePath || playlistDetail.thumbnailImg?.filePath;
    const url = await generateDynamicLink('studio-nft', nftId, playlistDetail.title, '', thumbnail);

    switch (action) {
      case "m14":
        copyToClipboard(url);
        notifier.info("link copied");
        break;
      case "m15":
        onShare(action, url, {
          id: userDetail._id,
          referralLink: url,
          eventType: ["sharedOutbound"],
          eventAsset: playListId,
          sharedBy: fullName(userDetail),
          eventValue: ["Studio"],
          socialMedia: "facebook",
        });
        break;
      case "m16":
        onShare(action, url, {
          id: userDetail._id,
          referralLink: url,
          eventType: ["sharedOutbound"],
          eventAsset: playListId,
          sharedBy: fullName(userDetail),
          eventValue: ["Studio"],
          socialMedia: "twitter",
        });
        break;
      case "Share on Instagram":
        onShare(action, url);
        break;

      default:
        break;
    }
  };
  const handleClick = (event) => {
    setOption(!option);

    putRecors({
      id: userDetail._id,
      referralLink: window.location.href,
      eventType: ["click"],
      eventAsset: playListId,
      sharedBy: fullName(userDetail),
      eventValue: ["Studio"],
      socialMedia: null,
    });
  };
  return (
    <Box className="___psong_detail">
      <Back />
      {playlistDetail["_id"] ? (
        <Box className="___psong_detail_box">
          <Box className="___song_detail_container">
            <Box className="___song_detail_banner">
              <Stack
                className="___song_detail_banner_detail"
                spacing={1.5}
                direction="row"
                gap="20px"
                padding="20px 20px"
              >
                <img
                  className="_img_large  br16"
                  src={
                    playlistDetail["GIF"]
                      ? playlistDetail["GIF"]["filePath"]
                      : playlistDetail["thumbnailImg"]
                        ? playlistDetail["thumbnailImg"]["filePath"]
                        : Images.default_playlist
                  }
                  alt="music"
                />
                <Stack
                  direction="column"
                  justifyContent="flex-start"
                  spacing={1}
                  sx={{ flex: "100%" }}
                >
                  <Typography className="fs-24 fw-b">
                    {playlistDetail["title"]}
                  </Typography>
                  <Stack direction="row" spacing={0.5} alignItems="center">
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <img src={Images.music_default} alt="" />
                      <Typography className="fs-14 white-secondary ">
                        {playlistDetail?.music.length}{" "}
                        {t("nftDetail.detail.songs")}
                      </Typography>
                    </Stack>
                    <PlayArrowRoundedIcon
                      className="white-secondary"
                      title="play"
                    // onClick={() => play()}
                    />
                    {playlistDetail["totalDuration"] ? (
                      <HMSTag
                        className="white-secondary fs-14 fw-b"
                        duration={playlistDetail["totalDuration"]}
                      />
                    ) : null}
                  </Stack>

                  <Stack direction="row" spacing={2}>
                    {/* <Stack direction="row" alignItems="center" spacing={1}>
                      <VisibilityIcon className="white-secondary" />{" "}
                      <Typography className="fs-14 white-secondary ">
                        {t("nftDetail.detail.views")} {playlistDetail["views"]}
                      </Typography>
                    </Stack> */}
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <img
                        style={{ width: "15px", height: "15px" }}
                        src={Images.listen}
                      />{" "}
                      <Typography className="fs-14 white-secondary ">
                        {t("analytics.card.card3")}:{" "}
                        {/* {t("nftDetail.detail.listens")}{" "} */}
                        {playlistDetail["listens"]}
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    sx={{ marginTop: "60px !important" }}
                  >
                    {/* <IconButton className="__icon_button">
                      <img src={Images.playlist_add} alt="" />
                    </IconButton> */}

                    {/* <Button
                      sx={{ whiteSpace: "pre" }}
                      variant="outlined"
                      color="default"
                      startIcon={<img src={Images.activity} alt="" />}
                      onClick={() =>
                        history.push(
                          `/app/PlaylistStatics/${nftId}/${playlistDetail?.createdBy}`
                        )
                      }
                    >
                      {t("nftDetail.detail.statics")}
                    </Button> */}
                    {isOwnerId(playlistDetail?.createdBy) ? (
                      <Box sx={{ position: "relative" }}>
                        <MoreVertIcon
                          className="_cp"
                          onClick={(e) => {
                            e.stopPropagation();
                            setMenu(!menu);
                          }}
                          color="default"
                        />

                        {menu ? (
                          <OutsideClickHandler
                            onOutsideClick={() => setMenu(false)}
                          >
                            <ProfileMenu
                              isMenu={true}
                              actions={[
                                {
                                  key: owners.private ? "m5" : "m6",
                                  action: owners.private
                                    ? t("dropMenu.m5")
                                    : t("dropMenu.m6"),
                                },
                              ]}
                              handleProfileMenuChoice={(action) =>
                                toggleMenu(action, owners._id, null)
                              }
                            />
                          </OutsideClickHandler>
                        ) : null}
                      </Box>
                    ) : null}

                    <Box sx={{ position: "relative" }}>
                      <Button
                        className="__play_all "
                        onClick={handleClick}
                        sx={{
                          width: "96px",
                          height: "36px !important",
                          fontSize: "12px !important",
                          fontWeight: "400 !important",
                        }}
                        variant="outlined"
                        color="default"
                        startIcon={
                          <IosShareIcon
                            className="__play_all_play"
                            color="default"
                          />
                        }
                      >
                        {t("nftDetail.detail.share")}
                      </Button>
                      {option ? (
                        <OutsideClickHandler
                          onOutsideClick={() => {
                            handleClosed();
                          }}
                        >
                          <ProfileMenu
                            right={""}
                            isHeader={true}
                            isLast={"40px"}
                            actions={[
                              { key: "m14", action: t("dropMenu.m14") },
                              {
                                key: "m15",
                                action: t("dropMenu.m15"),
                              },
                              {
                                key: "m16",
                                action: t("dropMenu.m16"),
                              },
                              // "Share on Instagram",
                              ,
                            ]}
                            handleProfileMenuChoice={(action) => (
                              handleCopy(action), handleClosed()
                            )}
                          />
                        </OutsideClickHandler>
                      ) : null}
                    </Box>
                  </Stack>
                </Stack>
              </Stack>
            </Box>
            <Box className="__back_cover">
              <img
                className=" mx-auto h100 w100 br16"
                src={
                  playlistDetail["GIF"]
                    ? playlistDetail["GIF"]["filePath"]
                    : playlistDetail["thumbnailImg"]
                      ? playlistDetail["thumbnailImg"]["filePath"]
                      : Images.default_playlist
                }
                alt="music"
              />
              <Box className="_cover_shadow"></Box>
            </Box>
          </Box>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  className="responsive-flex"
                  sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
                  icon={
                    <img
                      src={
                        value === 0 ? Images.all_music_active : Images.all_music
                      }
                      alt=""
                    />
                  }
                  label={t("nftDetail.tabs3.tab1")}
                  {...a11yProps(0)}
                />
                <Tab
                  className="responsive-flex"
                  sx={{ display: "flex", flexDirection: "row", gap: "5px" }}
                  icon={
                    <img
                      src={
                        value === 1
                          ? Images.playlist_info_active
                          : Images.playlist_info
                      }
                      alt=""
                    />
                  }
                  label={t("nftDetail.tabs3.tab2")}
                  {...a11yProps(1)}
                />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <PlaylistMusic
                createdBy={playlistDetail["createdBy"]}
                useDragHandle
                lockAxis="y"
                onSortEnd={onSortEnd}
                onSortStart={onSortStart}
                updateBeforeSortStart={updateBeforeSortStart}
                music={playlistDetail["music"]}
                playListId={playlistDetail["_id"]}
                handleTipClick={(m) => {
                  setOpenTipPlaylistMusic(true);
                  setMusicId(m["topTipperId"]);
                  setMusicArtist(m["topTipperName"]);
                }}
                toggleMenu={(action, id, index) => {
                  toggleMenu(action, id, index);
                }}
                play={(index) => play(index, index)}
                sort={true}
                playlistNftd={true}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Stack spacing={2} className="___song_detail_more">
                <Stack spacing={1.5} className="mt-30">
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography className="fs-14 fw-b">
                      {t("nftDetail.detail.ownedBy.text1")}
                    </Typography>
                  </Stack>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Avatar
                      src={
                        owners &&
                          owners["owner"] &&
                          owners["owner"]["profileImg"]["filePath"] !== ""
                          ? owners["owner"]["profileImg"]["filePath"]
                          : Images.default_user
                      }
                      alt=""
                    />
                    <Typography className="fs-14">
                      {fullName(owners["owner"] ? owners["owner"] : "")}
                    </Typography>
                    {owners && owners["isVerified"] ? (
                      <DoneIcon
                        color="primary"
                        sx={{
                          backgroundColor: "#2CF488",
                          borderRadius: "50%",
                          fontSize: "14px",
                          color: "#1E1E1E",
                          padding: "2px",
                        }}
                      />
                    ) : null}
                  </Stack>
                </Stack>
                {/* NOTE:For Other user */}
                {owners["owner"] && !isOwnerId(owners["owner"]["_id"]) ? (
                  <Stack
                    className="___buy_option __buy_container"
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Stack>
                      <Stack>
                        <Typography className="fs-14 white-secondary">
                          {t("nftDetail.detail.sale")}
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <img
                            style={{ width: "20px", height: "20px" }}
                            src={Images.siki_coin}
                            alt="siki"
                          />
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <Typography className="fs-24 fw-b">
                              {owners["sellingPrice"]
                                ? owners["sellingPrice"].toFixed(1)
                                : "0.0"}
                            </Typography>
                            <Typography>(${inUsd.toFixed()})</Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                      <Stack>
                        <Typography className="fs-14 white-secondary">
                          {t("nftDetail.detail.bidText")}
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <img
                            style={{ width: "20px", height: "20px" }}
                            src={Images.siki_coin}
                            alt="siki"
                          />
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <Typography className="fs-24 fw-b">
                              {owners["highestBid"]
                                ? owners["highestBid"].toFixed(1)
                                : "0.0"}
                            </Typography>
                            <Typography>(${bidInUsd.toFixed()})</Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                    </Stack>
                    <Stack direction="column" alignItems="center" spacing={1}>
                      {owners["onSale"] ? (
                        <Button
                          className="height50 transaction_button"
                          variant="contained"
                          color="primary"
                          onClick={() => setOpenBuy(true)}
                          style={{ width: "90px" }}
                        >
                          {t("nftDetail.nftRow.button4")}
                        </Button>
                      ) : null}
                      {owners["onAuction"] ? (
                        <Button
                          className="height50 transaction_button"
                          variant="outlined"
                          color="default"
                          style={{ width: "90px" }}
                          onClick={() => setOpenBid(true)}
                        >
                          {t("nftDetail.nftRow.button3")}
                        </Button>
                      ) : null}
                    </Stack>
                  </Stack>
                ) : null}
                {/* NOTE:put on sale for owner */}
                {owners["owner"] && isOwnerId(owners["owner"]["_id"]) ? (
                  <Stack
                    className="___buy_option"
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Stack>
                      <Stack>
                        <Typography className="fs-14 white-secondary">
                          {t("nftDetail.detail.priceText")}
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <img
                            style={{ width: "20px", height: "20px" }}
                            src={Images.siki_coin}
                            alt="siki"
                          />
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <Typography className="fs-24 fw-b">
                              {owners["sellingPrice"]
                                ? owners["sellingPrice"].toFixed(1)
                                : "0.0"}
                            </Typography>
                            <Typography>(${inUsd.toFixed()})</Typography>
                          </Stack>
                        </Stack>
                      </Stack>
                      <Stack>
                        <Typography className="fs-14 white-secondary">
                          {t("nftDetail.detail.bidText")}
                        </Typography>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <img
                            style={{ width: "20px", height: "20px" }}
                            src={Images.siki_coin}
                            alt="siki"
                          />
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                          >
                            <Typography className="fs-24 fw-b">
                              {owners["highestBid"]
                                ? owners["highestBid"].toFixed(1)
                                : "0.0"}
                            </Typography>
                            {owners["highestBid"] ? (
                              <Typography>
                                ($
                                {bidInUsd.toFixed()})
                              </Typography>
                            ) : null}
                          </Stack>
                        </Stack>
                      </Stack>
                    </Stack>
                    <Stack
                      direction="row"
                      alignItems="start"
                      sx={{ flexDirection: "column", gap: "10px" }}
                    >
                      {owners["onSale"] ? (
                        <Button
                          className="height50 transaction_button"
                          variant="outlined"
                          color="error"
                          onClick={() => {
                            setType("playlist");
                            cancelSell("playlist", nftId);
                          }}
                          startIcon={<CancelTwoToneIcon />}
                        >
                          {t("sellPopup.button1") +
                            " " +
                            t("sellPopup.button2")}
                        </Button>
                      ) : (
                        <Button
                          className="height50 transaction_button"
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            setType("playlist");
                            setShowSell(true);
                          }}
                        >
                          {t("nftDetail.detail.button1")}
                        </Button>
                      )}
                      {/* NOTE:Auction is compressed for now */}
                      {owners["onAuction"] ? (
                        <Button
                          className="height50 transaction_button"
                          variant="outlined"
                          color="error"
                          onClick={() => {
                            setType("playlist");
                            cancelAuction("playlist");
                          }}
                          startIcon={<CancelTwoToneIcon />}
                        >
                          {t("nftDetail.detail.button4")}
                        </Button>
                      ) : (
                        <Button
                          className="height50 transaction_button"
                          variant="outlined"
                          color="default"
                          onClick={() => {
                            setType("playlist");
                            setShowAuction(true);
                          }}
                        >
                          {t("nftDetail.detail.button2")}
                        </Button>
                      )}
                    </Stack>
                  </Stack>
                ) : null}
                {owners ? (
                  <PlaylistNftMoreData
                    playlistDetail={playlistDetail}
                    owners={owners}
                  />
                ) : null}
              </Stack>
            </TabPanel>
          </Box>
        </Box>
      ) : null}

      {loading ? <Loader /> : null}
      {showPlaylist ? (
        <AddMusicToPlaylist
          musicId={selectedMusicId}
          fromPlaylistId={playListId && createdBy && !isOwnerId(createdBy) ? playListId : undefined}
          open={showPlaylist}
          handleClose={() => setShowPlaylist(false)}
        />
      ) : null}

      {showSell ? (
        <SellPopup
          assetId={playlistDetail["_id"]}
          type={type}
          open={showSell}
          handleClose={(amount) => handleSell(amount)}
          nftId={nftId ? owners["_id"] : playlistDetail["_id"]}
          nftCount={
            nftId
              ? typeof owners["inSaleCount"] === "undefined"
                ? owners["currentCount"]
                : owners["currentCount"] > owners["inSaleCount"]
                  ? owners["currentCount"]
                  : owners["inSaleCount"]
              : playlistDetail["inSaleCount"]
                ? playlistDetail["inSaleCount"]
                : playlistDetail["nftCount"]
          }
        />
      ) : null}
      {showAuction ? (
        <AuctionPopup
          type={type}
          open={showAuction}
          handleClose={(amount) => handleAuction(amount)}
          nftId={owners["_id"]}
          assetId={playlistDetail["_id"]}
        />
      ) : null}
      {openBid ? (
        <BidPopup
          highestBid={owners["highestBid"] ? owners["highestBid"] : 100}
          open={openBid}
          handleClose={(amount) => handleBid(amount)}
          auctionId={owners?.auctionId || null}
          type="playlist"
        />
      ) : null}
      {openBuy ? (
        <BidPopup
          isBuy={true}
          highestBid={owners?.sellingPrice}
          open={openBuy}
          handleClose={(amount) => handleBuyed(amount)}
          auctionId={owners?._id}
          type={type}
        />
      ) : null}
      {showSuccess ? (
        <SuccessPopup
          open={showSuccess}
          handleClose={() => setShowSuccess(false)}
          message={t("success.message2")}
        />
      ) : null}
      {openTipPlaylistMusic ? (
        <TipPopup
          artist={musicArtist}
          id={musicId}
          open={openTipPlaylistMusic}
          isArtist={true}
          handleClose={handleCloseTip}
        />
      ) : null}
    </Box>
  );
}
